<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<p class="calibre23"> <span class="calibre8">Dedication</span> </p>
<p class="calibre4"> <span class="calibre5"> </span> </p>
<p class="calibre4"> <span class="calibre5"> </span> </p>
<p class="calibre4"> <span class="calibre5"> </span> </p>
<p class="calibre4"> <span class="calibre5"> </span> </p>
<p class="calibre2"> <span class="calibre5">This one is for you, Laura O’Connor,</span> </p>
<p class="calibre2"> <span class="calibre5">My smart and beautiful niece.</span> </p>
<p class="calibre2"> <span class="calibre5">In many ways Billy reminds me of you;</span> </p>
<p class="calibre2"> <span class="calibre5">Determined, hard-working, and blessed with a kind and loving heart.</span> </p>
<p class="calibre2"> <span class="calibre5">Love you!</span> </p>
<p class="calibre2"> <span class="calibre5"> </span> </p>
<p class="calibre24"> <span class="calibre8">As always, thank you to illustrator Faythe Payol</span> </p>
<p class="calibre24"> <span class="calibre8"> who does such a fantastic job of bringing my</span> </p>
<p class="calibre24"> <span class="calibre8">books to life.</span> </p>
<p class="calibre2"> <span class="calibre5"> </span> </p>
<p class="calibre22"> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0002.vue?080113d2